<template>
  <section
    class="home-page"
    :style="{
      'background-image':
        'url(' + bucketUrl + '/assets/background_landing-page.jpg)'
    }"
  >
    <header-logged-out />
    <v-container grid-list-xl>
      <v-row class="section-special-cards d-flex justify-center">
        <v-col cols="12" md="5" v-for="(c, index) in specialCards" :key="index">
          <v-card
            class="special-card"
            v-if="isSDECC == true && c.isSDECC == true"
          >
            <v-card elevation="2" class="pa-2 image-tile">
              <h2>{{ c.name }}</h2>
              <div
                class="background"
                :style="{ backgroundColor: c.color }"
              ></div>
            </v-card>
            <v-card-text>
              {{ c.description }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                outlined
                color="primary"
                class="button-size ml-5"
                :to="c.loginUrl"
              >
                login
              </v-btn>
              <v-spacer />
              <v-btn color="primary" class="button-size mr-5" :to="c.signupUrl">
                signup
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
            class="special-card"
            v-else-if="isSDECC == false && c.isSDECC == false"
          >
            <v-card elevation="2" class="pa-2 image-tile">
              <h2>{{ c.name }}</h2>
              <div
                class="background"
                :style="{ backgroundColor: c.color }"
              ></div>
            </v-card>
            <v-card-text>
              {{ c.description }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                outlined
                color="primary"
                class="button-size ml-5"
                :to="c.loginUrl"
              >
                login
              </v-btn>
              <v-spacer />
              <v-btn color="primary" class="button-size mr-5" :to="c.signupUrl">
                signup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <custom-snackbar />
  </section>
</template>

<script>
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import CustomSnackbar from '@/components/snackbar/snackbar'
import { mapState } from 'vuex'

export default {
  components: {
    HeaderLoggedOut,
    CustomSnackbar
  },
  computed: {
    ...mapState(['bucketUrl'])
  },
  data() {
    return {
      specialCards: [
        {
          name: 'Students',
          description: '',
          loginUrl: '/student/login',
          signupUrl: '/student/signup',
          color: '#172659',
          isSDECC: false
        },
        {
          name: 'Teachers',
          description: '',
          loginUrl: '/teacher/login',
          signupUrl: '/teacher/signup',
          color: '#006280',
          isSDECC: false
        },
        {
          name: 'Welcome',
          description: '',
          loginUrl: '/user/login',
          signupUrl: '/user/signup',
          color: '#F26A21',
          isSDECC: true
        }
      ],
      isSDECC: false
    }
  },
  mounted() {
    if (this.$store.state.isSDECC) {
      this.isSDECC = true
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  height: 100vh;
  background-size: cover;
  .v-card__actions {
    margin-top: 10px;
    padding: 10px;
  }

  .button-size {
    width: 38%;
  }

  .section-special-cards {
    padding-top: 20%;
  }

  .special-card {
    position: relative;
    padding-top: 70px;
    margin-bottom: 10vh;

    .image-tile {
      h2 {
        text-align: center;
        color: #fff;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
        font-size: 30px;
        display: block;
        line-height: 35px;
        width: 100%;
        padding: 10px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .background {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 175px;
      }
      width: 90%;
      position: absolute;
      top: -50%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
